module.exports = __webpack_public_path__ + "img/icon-scroll.b4b7ea5c.svg";